import RangeTable from 'components/offers/gateways/rules/RangeTable';
import RuleConfig from 'components/offers/gateways/Config';
import { Card, Typography } from 'antd';
import { EditButton } from '@refinedev/antd';
import { FinancialIconComponent } from 'assets/icons/financial';
import { IGatewayRule } from 'interfaces/gateways';
import { PageHeader } from 'components/professor_area/PageHeader';
import { ShowLayout } from 'components/layout/layout/ShowLayout';
import { translateRuleKind } from 'services/gateways';
import { useShow } from '@refinedev/core';

const { Title, Text } = Typography;

export const GatewayRuleShow = () => {
  const { queryResult } = useShow<IGatewayRule>();
  const { data, isLoading } = queryResult;
  const record = data?.data;
  return (
    <ShowLayout isLoading={isLoading}>
      <PageHeader
        title={record?.name}
        icon={FinancialIconComponent}
        actions={<EditButton type="primary" />}
      />

      <Card>
        {record && (
          <>
            <Title level={5}>ID</Title>
            <Text>{record?.id}</Text>
            <Title level={5}>Nome</Title>
            <Text>{record?.name}</Text>
            <Title level={5}>Tipo</Title>
            <Text>{translateRuleKind(record?.kind)}</Text>
            <Title level={4}>Configurações</Title>
            <RuleConfig config={record?.config} />
            {record?.kind === 'zip_code' && (
              <RangeTable name="CEP" rule={record} />
            )}
          </>
        )}
      </Card>
    </ShowLayout>
  );
};
